export default "__VITE_ASSET__DVqVs7Nm__"